import React from "react";

export default function Footer() {
  return (
    <footer className="footer">
      <div className="wrap footer-inner">
        <div className="footer-text">
          © {new Date().getFullYear()} CoreLink AI Technologies · London
        </div>
        <div className="footer-text">
          <a href="/privacy">Privacy</a> &nbsp;·&nbsp; <a href="/cookies">Cookies</a>
        </div>
      </div>
      <div className="wrap footer-legal">
        CoreLink AI Technologies Limited · Registered in England and Wales,
        company no.&nbsp;15841553 · Registered office: 3rd&nbsp;Floor,
        86-90&nbsp;Paul&nbsp;Street, London EC2A&nbsp;4NE, United&nbsp;Kingdom
      </div>
    </footer>
  );
}
